import { takeLatest, call, put } from 'redux-saga/effects';
import { AppTracking } from 'global/appTracking';
import { TENANT_ID } from 'global/environment';
import { initPassReset } from '../init-pass-reset/actions';
import { LoginEmailActions, loginEmailFail, loginEmailSuccess, loginEmailNewPasswordRequired } from './actions';
import { loginEmailAPI, completeNewPasswordAPI } from './api';

function* loginEmailEffect({ payload: { email, password } }) {
  try {
    const user = yield call(loginEmailAPI, email, password);

    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      yield put(loginEmailNewPasswordRequired(user));
      return;
    }

    if (JSON.parse(user.attributes['custom:data'])[TENANT_ID]) {
      yield put(loginEmailSuccess(user));
      AppTracking.authEvent({ action: 'Login', label: 'Email' });
    } else {
      yield put(loginEmailFail('incorrectCredentials'));
    }
  } catch (e) {
    if (e.code === 'PasswordResetRequiredException') {
      yield put(initPassReset(email));
    } else if (e.message === 'User is disabled.') {
      yield put(loginEmailFail('emailNotFound'));
    } else {
      yield put(loginEmailFail('incorrectCredentials'));
    }
  }
}

function* completeNewPasswordEffect({ payload: { user, newPassword } }) {
  try {
    const updatedUser = yield call(completeNewPasswordAPI, user, newPassword);

    if (JSON.parse(updatedUser.attributes['custom:data'])[TENANT_ID]) {
      yield put(loginEmailSuccess(updatedUser));
    } else {
      yield put(loginEmailFail('incorrectCredentials'));
    }
  } catch (e) {
    yield put(loginEmailFail('passwordUpdateFailed'));
  }
}

export const loginEmailEffects = [
  takeLatest(LoginEmailActions.LOGIN_EMAIL, loginEmailEffect),
  takeLatest(LoginEmailActions.LOGIN_EMAIL_COMPLETE_NEW_PASSWORD, completeNewPasswordEffect),
];
